import * as React from 'react'
import {
  IonRow, IonCol, IonContent, IonCheckbox,
  useIonAlert,
} from '@ionic/react'

import { Icon } from '@iconify/react'
import axios from 'axios'
import { ListContainer } from '../../consultant/StyledContainers'
import { WidgetTitles, ViewButton } from '../../maps/WidgetContainers'
import { getCurrentLevel, getColor } from '../../maps/apps/AppMap'
import { SherpaButton } from '../../GlobalContainers'

import { useRiskRegister } from '../../../hooks/risks/useRiskRegister'
import { Asset } from '../types/Assets'
import { getListOfAssets } from '../utils/FormatListViews'
import { FocusedActionKind, ViewsActionKind } from '../../../hooks/risks/helpers/StateReducers'
import { BlueButton } from '../../projects/StyledContainers'
import { RedButton } from '../../incident-management/StyledContainers'
import { useWorkspace } from '../../../hooks/useWorkspace'
import useApi from '../../../hooks/testHooks'

/**
 *  ===========================
 *       Asset List View
 *  ===========================
 */

const AssetRegisterV2 = () : JSX.Element => {
  /* Retrieve  hooks data/functionality */
  const {
    assets, dispatchAsset, dispatchViews, editing, deleteAssetList, regions,
    setSelectedAsset, setShowSelectedAsset, setAssets,
  } = useRiskRegister()

  const { workspace } = useWorkspace()
  const [ionAlert] = useIonAlert()
  const apiHook = useApi()

  const handleFocus = (selected) : void => {
    dispatchViews({ type: ViewsActionKind.MAP_VIEW })
    setSelectedAsset(selected)
    setShowSelectedAsset(true)
  }

  const handleCheckboxes = (checked: boolean, id: number) => {
    setDeleteAssets({ ...deleteAssets, [id]: checked })
  }

  const handleDelete = (val) => {
    ionAlert({
      header: 'Confirmation',
      inputs: [
        {
          name: 'action',
          type: 'radio',
          label: 'Archive',
          value: 'Archive',
        },
        {
          name: 'action',
          type: 'radio',
          label: 'Delete',
          value: 'Delete',
          checked: true, // Default to Archive
        },
      ],
      message: 'Are you sure you want to delete this asset?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Action canceled')
          },
        },
        {
          text: 'Confirm',
          handler: (data) => {
            // Log the entire data object to check its structure

            // Ensure data.action exists before proceeding
            const selectedAction = data

            if (selectedAction === 'Archive') {
              console.log('Archiving', val)
              apiHook.archiveAssets([val.id])
                .then((data) => {
                  setAssets(assets.filter((asset) => asset.id !== val.id))
                })
            } else if (selectedAction === 'Delete') {
              console.log('Delete', val)
              apiHook.archiveAssets([val.id])
                .then((data) => {
                  setAssets(assets.filter((asset) => asset.id !== val.id))
                })
            }
          },
        },
      ],
    })
  }

  const countyRegionMap = new Map()
  regions.forEach((region) => {
    region.counties.forEach((county) => {
      countyRegionMap.set(county.id, { countyName: county.name, regionName: region.name })
    })
  })

  /* Subscribe list view assets to hook */

  return (

    <ListContainer>
      <WidgetTitles style={{ height: '10%', paddingRight: '0', paddingLeft: '0' }}>
        <IonRow style={{ height: '100%' }} className='ion-align-items-center'>
          <IonCol className='ion-text-center' size='2'>Key Asset</IonCol>
          <IonCol className='ion-text-center' size='2'>Type</IonCol>
          <IonCol className='ion-text-center' size='2'>Region</IonCol>
          <IonCol className='ion-text-center' size='2'>County</IonCol>
          <IonCol className='ion-text-center' size='2'>Date Modified</IonCol>
          <IonCol className='ion-text-center' size='2'></IonCol>
        </IonRow>
      </WidgetTitles>
      <div style={{ height: '95%' }}>
        <IonContent style={{ '--background': 'white' }}>
          {
            assets.map((asset: any, index: number) => (
              <IonRow
                key={asset.id}
                style={{ backgroundColor: getColor(index), height: '10%' }}
                className='ion-align-items-center'
              >
                <IonCol className='ion-text-center' size='2'>
                  <ViewButton onClick={() => handleFocus(asset)}>
                    { asset.name }
                  </ViewButton>
                </IonCol>
                <IonCol className='ion-text-center' size='2'>{ asset.asset_type }</IonCol>
                <IonCol className='ion-text-center' size='2'>Test Region</IonCol>
                <IonCol className='ion-text-center' size='2'>Test County</IonCol>
                <IonCol className='ion-text-center' size='2'>{ asset.updated_at}</IonCol>
                <IonCol size='2'>
                  <BlueButton onClick={() => handleFocus(asset)}>View</BlueButton> / <RedButton onClick={() => handleDelete(asset)}>Delete</RedButton>
                </IonCol>
              </IonRow>
            ))
          }
        </IonContent>
      </div>
    </ListContainer>
  )
}

export default AssetRegisterV2
